/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Brand_Badge_Line11Inputs */

const vi_sitesettings_brand_badge_line11 = /** @type {(inputs: Sitesettings_Brand_Badge_Line11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dòng 1`)
};

/**

* @param {Sitesettings_Brand_Badge_Line11Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_brand_badge_line11 = /** @type {((inputs?: Sitesettings_Brand_Badge_Line11Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Brand_Badge_Line11Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_brand_badge_line11(inputs)
});
export { sitesettings_brand_badge_line11 as "siteSettings_brand_badge_line1" }